import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { MediaApi } from '../api/media-api';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class MediaRepository extends Repository {
  constructor(private mediaApi: MediaApi) {
    super();
  }

  getUploadImageSignedURL(file: File): Observable<string> {
    return this.mediaApi.getUploadImageSignedURL(file).pipe(
      concatMap((signedURL) => {
        return this.mediaApi.uploadMediaURL(signedURL.uploadURL, file).pipe(
          map((res) => {
            return signedURL.fileUrl;
          })
        );
      })
    );
  }

  getUploadFileSignedURL(file: File): Observable<string>{
    return this.mediaApi
    .getUploadFileSignedURL(file)
    .pipe(
      concatMap((signedURL)=>{
        return this.mediaApi
        .uploadMediaURL(signedURL.uploadURL, file)
        .pipe(
          map(()=>{
            return signedURL.fileUrl;
          })
        )
      })
    )
  }
}
